<template>
  <div class="auth font-body flex justify-center items-center flex-col h-full">
    <div class="flex items-center">
      <div class="flex-1 mt-10 ">
        <img
          class="m-auto bg-gray-200 rounded-lg"
          src="@/assets/img/logo_tipo.png"
          alt="Logo Estico"
          title="Estico"
          width="225px"
        />
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'auth',
  components: {}
}
</script>

<style>

body,html, #app{
  height: 100%;
}

</style>
